var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "call"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_302_2677",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_302_2677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "call_2",
    d: "M20.45 21C18.3 21 16.2042 20.5208 14.1625 19.5625C12.1208 18.6042 10.3125 17.3375 8.7375 15.7625C7.1625 14.1875 5.89583 12.3792 4.9375 10.3375C3.97917 8.29583 3.5 6.2 3.5 4.05C3.5 3.75 3.6 3.5 3.8 3.3C4 3.1 4.25 3 4.55 3H8.6C8.83333 3 9.04167 3.075 9.225 3.225C9.40833 3.375 9.51667 3.56667 9.55 3.8L10.2 7.3C10.2333 7.53333 10.2292 7.74583 10.1875 7.9375C10.1458 8.12917 10.05 8.3 9.9 8.45L7.475 10.9C8.175 12.1 9.05417 13.225 10.1125 14.275C11.1708 15.325 12.3333 16.2333 13.6 17L15.95 14.65C16.1 14.5 16.2958 14.3875 16.5375 14.3125C16.7792 14.2375 17.0167 14.2167 17.25 14.25L20.7 14.95C20.9333 15 21.125 15.1125 21.275 15.2875C21.425 15.4625 21.5 15.6667 21.5 15.9V19.95C21.5 20.25 21.4 20.5 21.2 20.7C21 20.9 20.75 21 20.45 21ZM6.525 9L8.175 7.35L7.75 5H5.525C5.60833 5.68333 5.725 6.35833 5.875 7.025C6.025 7.69167 6.24167 8.35 6.525 9ZM19.5 18.95V16.75L17.15 16.275L15.475 17.95C16.125 18.2333 16.7875 18.4583 17.4625 18.625C18.1375 18.7917 18.8167 18.9 19.5 18.95Z",
    fill: "#00A693"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6cac88ec7f95a4c90f0adf7c90409ebe.svg";
export { ForwardRef as ReactComponent };